module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-Bold-WebS.54c39695.woff";